import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MainProduct } from './components/MainProduct';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyMobileCta } from './components/StickyMobileCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div lang="fr" className="min-h-screen w-full bg-ink text-cream" data-id="element-0" data-mp="2wi5m1f302hnq">
      <PromoBar data-id="element-1" data-mp="28sur4e8bzhhi" />
      <Hero data-id="element-2" data-mp="28sbend1g9lav" />
      <main data-id="element-3" data-mp="23vck4tdvjcc5">
        <PainPoints data-id="element-4" data-mp="23vkzqt1dsvr1" />
        <MainProduct data-id="element-5" data-mp="23u9tmmkgrbwr" />
        <Bonuses data-id="element-6" data-mp="23utb6267bya9" />
        <HowItWorks data-id="element-7" data-mp="23t8g8bfz6dbv" />
        <Testimonials data-id="element-8" data-mp="3ijxsgzk2wgo4" />
        <Offer data-id="element-9" data-mp="3ikr0e3urxc7u" />
        <Guarantee data-id="element-10" data-mp="3ij64oawq3n8e" />
        <Faq data-id="element-11" data-mp="3ijpc2xoqyt86" />
        <FinalCta data-id="element-12" data-mp="3ihuyy5jpw5en" />
      </main>
      <StickyMobileCta data-id="element-13" data-mp="3ml1419v3fqjj" />
    </div>;
}